import React, { useState, useEffect } from "react";
import "../../scss/dashboard/crearplantilla.css";
import { FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import HookForm from "./formas/editBasicData";
import DatosPago from "./formas/editPayData";
import PlantillasConfig from "./formas/editConfig";
import UploadPdf from "./formas/dragDocument";

const PublicTemplateSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  categories: Yup.array()
    .of(Yup.string())
    .min(1, "Required")
    .required("Required"),
  price: Yup.string().required("Required"),
  bankData: Yup.object().shape({
    name: Yup.string().required("Required"),
    accountOwnerName: Yup.string().required("Required"),
    standarizedBankCode: Yup.string().required("Required"),
  }),
});

export function PublicTemplateForm({
  currentStep,
  defaultValues = {},
  saveMode = "last",
  lastStep = 2,
  isRequestingTemplate,
  onNextStep,
  onSave,
}) {
  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(PublicTemplateSchema),
  });
  const { reset } = methods;

  useEffect(() => {
    reset({
      name: defaultValues.name || "",
      description: defaultValues.description || "",
      categories: defaultValues.categories || [],
      price: defaultValues.stripeInfo?.price / 100 || "",
      active: defaultValues.active || false,
      bankData: {
        name: defaultValues.bankData?.name || "",
        accountOwnerName: defaultValues.bankData?.accountOwnerName || "",
        standarizedBankCode: defaultValues.bankData?.standarizedBankCode || "",
      },
    });
  }, [
    reset,
    defaultValues.name,
    defaultValues.active,
    defaultValues.description,
    defaultValues.categories,
    defaultValues.bankData,
    defaultValues.stripeInfo,
  ]);

  const handleNextStep = async (evt, data = {}) => {
    console.log({ errors: methods.errors, a: methods.getValues() });

    if (currentStep === 0) {
      const isValid = await methods.trigger(["name", "description"]);
      if (!isValid) return;
    }
    if (currentStep === 1) {
      const isValid = await methods.trigger(["categories", "price"]);
      if (!isValid) return;
    }
    // if (currentStep === 2) {
    //   const isValid = await methods.trigger([
    //     "bankData.name",
    //     "bankData.accountOwnerName",
    //     "bankData.standarizedBankCode",
    //   ]);
    //   if (!isValid) return;
    // }
    const shouldSave =
      (saveMode === "last" && currentStep === lastStep) || saveMode === "every";
    console.log({ saveMode, shouldSave });
    if (shouldSave) onSave({ ...data, ...methods.getValues() });
    if (currentStep === lastStep) return;
    onNextStep();
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <HookForm onSubmit={handleNextStep} />;
      case 1:
        return <PlantillasConfig onSubmit={handleNextStep} />;
      // case 2:
      //   return (
      //     <DatosPago onSubmit={handleNextStep} />
      //   );
      case 2:
        return (
          <UploadPdf
            isRequestingTemplate={isRequestingTemplate}
            onSubmit={handleNextStep}
          />
        );

      default:
        return "Unknown step";
    }
  }

  return (
    <FormProvider {...methods}>{getStepContent(currentStep)}</FormProvider>
  );
}
